<template>
  <div class="custom-image-wrap">
    <div
      class="image-box"
      :class="{ 'is-video': isVideo, 'can-preview': isVideo && enableVideoPreview }"
      :style="{ width: width + 'px', height: height + 'px' }"
      @click="handlePreview"
    >
      <video v-if="isVideo" class="media" :src="imageUrl" muted></video>
      <img v-else-if="imageUrl" class="media" :src="imageUrl" alt="">
      <img v-else class="media" src="https://imgb.woyoubooking.com/common/empty_pro_img.png" alt="">
      <div v-if="isVideo && enableVideoPreview" class="play-mask">
        <a-icon type="play-circle" class="play-icon"/>
      </div>
    </div>
    <a-modal
      title="视频预览"
      :visible="videoVisible"
      :footer="null"
      :width="800"
      destroyOnClose
      @cancel="closeVideoPreview"
    >
      <video
        v-if="videoVisible"
        ref="previewVideo"
        class="preview-video"
        :src="imageUrl"
        controls
        autoplay
      ></video>
    </a-modal>
  </div>
</template>

<script>
import ossUploadMixins from '@/utils/mixins/ossUploadMixins'

export default {
  name: 'CustomImage',
  mixins: [ossUploadMixins],
  props: {
    width: {
      type: String | Number,
      default: 50
    },
    imageUrl: {
      type: String,
      default: ''
    },
    height: {
      type: String | Number,
      default: 50
    },
    enableVideoPreview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      videoVisible: false
    }
  },
  computed: {
    isVideo() {
      return this.isVideoUrl(this.imageUrl)
    }
  },
  methods: {
    handlePreview() {
      if (!this.isVideo || !this.enableVideoPreview) {
        return
      }
      this.videoVisible = true
    },
    closeVideoPreview() {
      const video = this.$refs.previewVideo
      if (video) {
        video.pause()
        video.currentTime = 0
      }
      this.videoVisible = false
    }
  }
}
</script>
<style scoped lang="less">
.image-box {
  position: relative;
  overflow: hidden;

  &.can-preview {
    cursor: pointer;
  }

  .media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    background: #000;
  }

  .play-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    pointer-events: none;
  }

  .play-icon {
    font-size: 28px;
    color: #fff;
  }
}

.preview-video {
  width: 100%;
  max-height: 450px;
  background: #000;
}
</style>
